import { ButtonsShowHistory, ButtonsShowReports } from '@/components/custom';
import { VerificationTypesEnum } from '@/lib/enum.ts';

const ControlsLeftButtons = () => (
	<div className='flex items-center space-x-2 justify-end'>
		<ButtonsShowReports
			type={VerificationTypesEnum.PROFILE_PHOTO}
			tab='verifiers' />
		<ButtonsShowHistory
			type={VerificationTypesEnum.PROFILE_PHOTO}
			className='ms-auto h-0 md:h-9' />
	</div>
);

export default ControlsLeftButtons;
